module.exports = __webpack_public_path__ + "img/eraser2.8c3968de.webp";